module.exports = __webpack_public_path__ + "static/img/img-install-tag-bus-bottom-detail-top.e6aec76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-bus-bottom-detail-top.svg
// module id = 1781
// module chunks = 1